import { Box, Flex, HStack, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Spinner, Text, useColorModeValue, useToast } from "@chakra-ui/react"
import { FileArrowDown, Files } from "@phosphor-icons/react"
import { useSelector } from "react-redux"
import { State } from "state/reducers"

import pusher from "services/pusher"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { reportCreator } from "state/index"
import { Report } from "interfaces/report"
import dateFormat from "functions/dateFormat"
import { useGetLastReports, useGetReport } from "hooks/useReports"

interface ReportPusher {
    message: string
    report: Report
}

const Reports = () => {
    const { loading } = useGetLastReports();
    const { id } = useSelector(({ auth }: State) => auth)
    const { lastReports } = useSelector(({ reports }: State) => reports)
    const dispatch = useDispatch()
    const { updateReport } = bindActionCreators(reportCreator, dispatch)

    const [getReportUrl, {}] = useGetReport();

    const toast = useToast()

    const hasLoadingReport = lastReports.find(rep => rep.status === "generating")

    const iconColor = useColorModeValue("#000", "#FFF")

    // useEffect(() => {
    //     const channel = pusher.subscribe(`private-user.${id}`);
    //     channel.bind('report-finished', (data: ReportPusher) => {
    //         if (data.report) {
    //             updateReport(data.report)
    //             if (!toast.isActive("reportFinished_" + data.report.id))
    //                 toast({
    //                     id: "reportFinished_" + data.report.id,
    //                     title: `Relatório: ${data.report.name} finalizado`,
    //                     duration: 4000,
    //                     position: "bottom",
    //                     status: "success"
    //                 })
    //         }
    //     });

    //     return () => {
    //         channel.unbind('report-finished');
    //         pusher.unsubscribe(`private-user.${id}`);
    //     };
    // }, [])

    const onDownload = async (url: string) => {
        const { data } = await getReportUrl({
            variables: {
                path: url
            }
        })
        const fileUrl = data.getReportUrl;

        window.open(fileUrl);
    }

    return (
        <Menu closeOnSelect={false}>
            <MenuButton backgroundColor="transparent" >
                {
                    hasLoadingReport ?
                        <Flex alignItems="center">
                            <Spinner size="sm" color="white" emptyColor='gray.600' />
                        </Flex>
                        : <Files size="24px" weight="fill" color="#FFF" />
                }
            </MenuButton>
            <MenuList className="customScrollbar" maxH="178px" overflowY="auto">
                {
                    loading || lastReports.length === 0 ?
                        <Box p={8}><Text>Não há relatórios recentes.</Text></Box>
                        : lastReports.map(rep => (
                            <MenuItem key={rep.id} py={8} h="40px" onClick={() => rep.url && onDownload(rep.url)}>
                                <HStack spacing={4}>
                                    {
                                        rep.status === 'generating' ?
                                            <Spinner size="sm" />
                                            : <FileArrowDown size="22px" weight="fill" color={iconColor} />
                                    }
                                    <Flex direction="column">
                                        <Text>{rep.name}</Text>
                                        <Text fontSize="sm">{dateFormat(rep.created_at, "dd/MM/yyyy HH:mm:ss")}</Text>
                                    </Flex>
                                </HStack>
                            </MenuItem>
                        ))
                }
            </MenuList>
        </Menu>
    )
}

export default Reports